import styled from 'styled-components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';

export default styled.div`
  font-weight: bold;
  text-align: center;
  color: ${(props) => props.theme.colors.protectItFontColor || '#fefefe'};
  font-size: 22px;
  line-height: 1;
  margin-bottom: 19px;
  @media ${BREAK_POINTS.mobileBig} {
    font-size: 28px;
  }
  @media ${BREAK_POINTS.tablet} {
    font-size: 40px;
    line-height: 40px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/ProtectItTitle.tsx